module.exports = __webpack_public_path__ + "static/img/WEBDE.479e3d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/WEBDE.svg
// module id = QlGI
// module chunks = 2